import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';

export interface CustomButtonProps extends MuiButtonProps {
  glow?: boolean;
  iconRight?: React.ReactNode;
  iconLeft?: React.ReactNode;
}

export const Button: React.FC<CustomButtonProps> = ({
  children,
  glow = false,
  iconRight,
  iconLeft,
  sx,
  ...props
}) => {
  return (
    <MuiButton
      {...props}
      startIcon={iconLeft}
      endIcon={iconRight}
      sx={{
        ...(glow && {
          boxShadow: '0 0 20px rgba(0, 102, 255, 0.3)',
          '&:hover': {
            boxShadow: '0 0 30px rgba(0, 102, 255, 0.6)',
          },
        }),
        ...sx,
      }}
    >
      {children}
    </MuiButton>
  );
};

export default Button;
